import Swiper from "swiper"
import { Navigation, Keyboard, Mousewheel } from "swiper/modules"
import { mediumUpBreakPoint } from "../util/helpers.js"

// Main gallery swiper
const swiperEl = document.querySelector(".gallery .swiper")
if (swiperEl) {
  const slideEls = swiperEl.querySelectorAll(".swiper-slide")
  const containerWidth = swiperEl.offsetWidth
  const spaceBetween = 8

  const totalSlideWidth = Array.from(slideEls).reduce(
    (sum, slide) => sum + slide.offsetWidth + spaceBetween,
    0,
  )

  const hasEnoughForLoop = totalSlideWidth > containerWidth * 2
  const fitsWithinView = totalSlideWidth <= containerWidth
  const shouldCenterGallery =
    fitsWithinView && slideEls.length <= 3 && mediumUpBreakPoint.matches

  if (shouldCenterGallery) {
    swiperEl.querySelector(".gallery .swiper-wrapper").style.justifyContent =
      "center"
  }

  const swiper = new Swiper(".gallery .swiper", {
    modules: [Navigation, Mousewheel],
    slidesPerView: "auto",
    centeredSlides: hasEnoughForLoop,
    loop: hasEnoughForLoop,
    freeMode: !hasEnoughForLoop,
    autoHeight: false,
    spaceBetween,
    navigation: {
      nextEl: ".gallery .swiper-button-next",
      prevEl: ".gallery .swiper-button-prev",
    },
  })
  // Lightbox swiper (initialized but not shown)
  const lightboxSwiper = new Swiper(".swiper-lightbox", {
    modules: [Navigation, Keyboard],
    keyboard: {
      enabled: true,
    },
    slidesPerView: 1,
    loop: true,
    spaceBetween,
    navigation: {
      nextEl: ".lightbox .swiper-button-next",
      prevEl: ".lightbox .swiper-button-prev",
    },
  })

  // Open lightbox on slide click
  const slides = document.querySelectorAll(".gallery .swiper-slide")
  const lightbox = document.querySelector(".lightbox")

  slides.forEach((slide) => {
    slide.addEventListener("click", () => {
      lightbox.classList.add("is-open")
      document.body.style.overflow = "hidden"
      lightboxSwiper.update()

      if (hasEnoughForLoop) {
        const slideIndex = parseInt(
          slide.getAttribute("data-swiper-slide-index"),
        )
        lightboxSwiper.slideToLoop(slideIndex, 0)
      } else {
        const slideIndex = parseInt(slide.getAttribute("data-slide-index"))
        lightboxSwiper.slideToLoop(slideIndex, 0)
      }
    })
  })

  // Close lightbox
  const closeButton = document.querySelector(".lightbox-close")
  if (closeButton) {
    closeButton.addEventListener("click", () => {
      lightbox.classList.remove("is-open")
      document.body.style.overflow = ""
    })
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && lightbox?.classList.contains("is-open")) {
      lightbox.classList.remove("is-open")
      document.body.style.overflow = ""
    }
  })

  lightbox?.addEventListener("click", (e) => {
    if (e.target === lightbox) {
      lightbox.classList.remove("is-open")
      document.body.style.overflow = ""
    }
  })
}
